// #deprecated
import Button from "../Form/Button";
import { useUserContext } from "context/UserContext";
import { useLang } from "hooks/useLang";
import { IFinalEvent } from "types/event";
import { sortPrice } from "utils/helpers/sortEventPrice";
import PriceComponent from "components/atoms/PriceComponent";
import Link from "next/link";
import { useRouter } from "next/router";
import { hasMultiplePrices } from "utils/helpers/eventPrice";
import { twMerge } from "tailwind-merge";
import { useCartDispatch } from "hooks/useCartV2";
import { OptimizedEvent } from "types/optimizedEvent";

interface IProps {
  event: IFinalEvent;
  className?: string;
  verificationModalOpen: boolean;
  setOpenVerificationModal: (value: boolean) => void;
  isExpired: boolean;
}
const ActionCard = ({
  event,
  setOpenVerificationModal,
  className: customClassName,
  verificationModalOpen,
}: IProps) => {
  const { t, isAr } = useLang();
  const { token, user } = useUserContext();

  const router = useRouter();

  // Split the asPath into pathname and query string
  const [pathWithoutQuery, queryString] = router.asPath.split("?");

  // Construct the new path by adding '/book' before the query parameters
  const newPath = `${pathWithoutQuery}/book`;

  // Reconstruct the href, including query parameters if they exist
  const href = queryString ? `${newPath}?${queryString}` : newPath;

  const cartDispatch = useCartDispatch();

  const price = sortPrice(event);

  const isUserVerified =
    user?.verification?.is_email_verified ||
    user?.verification?.is_phone_verified;

  const handleLinkClick = (e) => {
    const setEventTitle = () => {
      cartDispatch({ type: "SET_EVENT_TITLE", payload: event?.ar_title });
    };

    const navigateToBookingPage = () => {
      // e.preventDefault() // Prevent navigation
      setEventTitle();
      // push(`${router.asPath}/book`)
    };

    if (!token) {
      // User is not logged in

      setEventTitle();
      navigateToBookingPage();
    } else {
      // User is logged in
      if (isUserVerified) {
        setEventTitle();
        navigateToBookingPage();
      } else {
        e.preventDefault(); // Prevent navigation
        setOpenVerificationModal(true); // Open verification modal
      }
    }
  };

  const checkIfEventExpired = () => {
    const today = new Date();
    const eventDate = new Date(event?.event_date?.ending_date);
    const result = today > eventDate;
    return result;
  };

  const isEventExpired = checkIfEventExpired();

  function everyFunc(el: { end_slot: string | number | Date }) {
    const today = new Date();
    if (today > new Date(el.end_slot)) {
      return true;
    } else {
      return false;
    }
  }

  const isTimeSlotsExpired = event?.time_slots?.every(everyFunc);

  const isBookingDisabled = () => {
    const hasNoAvailableTickets = event?.availableTickets?.length === 0;
    const hasNoTimeSlots = event?.time_slots?.length === 0;
    const hasExpiredTimeSlots = !isEventExpired && isTimeSlotsExpired;

    return hasNoAvailableTickets || hasNoTimeSlots || hasExpiredTimeSlots;
  };

  const isButtonDisabled = isBookingDisabled();

  const isMultiplePrices = hasMultiplePrices(event);
  const isBookingEnabled = event?.booking?.is_enable_booking !== false;
  const getButtonLabel = () => {
    if (isBookingEnabled) {
      return t("book_now");
    }
    if (isAr) {
      return event.booking?.ar_message ?? t("not_available");
    }
    return event.booking?.en_message ?? t("not_available");
  };

  const renderActionButton = () => {
    if (isEventExpired) {
      return (
        <Button disabled className="w-full p-2">
          {t("event_expired")}
        </Button>
      );
    }

    if (isButtonDisabled) {
      return (
        <Button disabled className="w-full p-2 capitalize">
          {t("no_tickets_available")}
        </Button>
      );
    }
    //TODO: refactor. use link or button. not both.
    return (
      <Link
        href={href}
        className="w-full"
        passHref
        onClick={isBookingEnabled ? handleLinkClick : (e) => e.preventDefault()}
      >
        <Button
          disabled={!isBookingEnabled}
          className="w-full p-2"
          onClick={isBookingEnabled ? handleLinkClick : undefined}
        >
          {getButtonLabel()}
        </Button>
      </Link>
    );
  };

  return (
    <div
      className={twMerge(
        `${verificationModalOpen ? "block" : "sticky z-10"} 
        bottom-0 left-0 right-0 mx-auto 
        flex w-full max-w-[1200px] flex-col items-center justify-center 
        bg-opacity-50 px-5 gap-y-3 py-3
        border border-b-0 border-white border-opacity-20
        backdrop-blur-sm dark:bg-primary-theme-400 dark:bg-opacity-50 rounded-t-xl
        transition-all duration-300 ease-in-out transform translate-y-0
        opacity-100`,
        customClassName
      )}
    >
      {event?.availableTickets?.length === 0 ? null : (
        <div className="flex w-full flex-row items-center justify-between">
          <span className="text-lg font-semibold text-primary-theme-400 dark:text-white">
            {isMultiplePrices ? t("starting_from") : t("Ticket_price")}
          </span>
          {price ? (
            <PriceComponent
              className="flex flex-row items-center text-lg font-bold text-primary-theme-400 dark:text-white"
              price={
                price?.discount?.previous_value
                  ? price?.discount?.current_value
                  : price?.price
              }
            />
          ) : null}
        </div>
      )}

      {renderActionButton()}
    </div>
  );
};

export default ActionCard;
